import {Component, Input, OnInit} from '@angular/core';
import {trigger, transition, useAnimation} from '@angular/animations';
import {AnimationType, fadeIn, fadeOut} from './carousel.animations';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  animations: [
    trigger('slideAnimation', [
      transition('void => fade', [
        useAnimation(fadeIn, {
          params: {
            time: '500ms'
          }
        })
      ]),
      transition('fade => void', [
        useAnimation(fadeOut, {
          params: {
            time: '500ms'
          }
        })
      ]),
    ])
  ]
})
export class CarouselComponent implements OnInit {
  /**
   * Slides to show
   * @var {Array<any>}
   */
  @Input() slides: Array<any>;

  /**
   * Animation to use when changing a slide
   * @var {string}
   */
  animationType: string;

  /**
   * Current slide
   * @var {number}
   */
  currentSlide: number;

  /**
   * Component constructor
   */
  constructor() {
    this.currentSlide = 0;
    this.animationType = AnimationType.Fade;
  }

  /**
   * On init method
   */
  public ngOnInit() {
    this._preloadImages();
  }

  /**
   * Navigates to the previous slide
   *
   * @returns {void}
   */
  public goToPreviousSlide(): void {
    if (!this.shouldDisablePreviousButton()) {
      const previous = this.currentSlide - 1;
      this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
    }
  }

  /**
   * Navigates to the next slide
   *
   * @returns {void}
   */
  public goToNextSlide(): void {
    if (!this.shouldDisableNextButton()) {
      const next = this.currentSlide + 1;
      this.currentSlide = next === this.slides.length ? 0 : next;
    }
  }

  /**
   * Checks if previous button should be disabled
   *
   * @returns {boolean}
   */
  public shouldDisablePreviousButton(): boolean {
    return this.currentSlide === 0;
  }

  /**
   * Checks if next button should be disabled
   *
   * @returns {boolean}
   */
  public shouldDisableNextButton(): boolean {
    return this.currentSlide + 1 === this.slides.length;
  }

  /**
   * Navigates to a specific slide
   *
   * @param index
   *
   * @returns {void}
   */
  public goToSlide(index: number): void {
    this.currentSlide = index;
  }

  /**
   * Preloads the carousel images
   *
   * @private
   * @returns {void}
   */
  private _preloadImages(): void {
    for (const slide of this.slides) {
      new Image().src = slide.src;
    }
  }
}
